<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>

    <!-- Header -->
    <header-component headerTitle="Return Approval" />

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-repair" v-model="filterPopup" max-width="1145px" >
        <v-card class="filter_ui">
          <v-card-actions>
            <!-- <v-autocomplete v-model="return_type_search" variant = "outlined" :items="return_types" item-title="original_code" item-value="id" label="Return Types" > </v-autocomplete> -->
            <v-text-field variant="outlined" prepend-inner-icon="mdi-magnify" v-model="ra_location_search" label="Location" class="ma-2" ></v-text-field>
            <v-text-field variant="outlined" prepend-inner-icon="mdi-magnify" v-model="ra_branch_search" label="Branch" class="ma-2" ></v-text-field>
            <!-- <v-autocomplete
              v-model="region_search"
              variant = "outlined"
              :items="regions"
              item-title="original_code"
              item-value="id"
              label="Region"
            >
            </v-autocomplete> -->
            <v-text-field variant="outlined" prepend-inner-icon="mdi-magnify" v-model="region_search" label="Region" class="ma-2" ></v-text-field>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" class="text-none" variant="outlined" text color="primary" @click="closeFilterpopup" >Cancel</v-btn >
            <v-btn size="small" class="text-none" color="primary" variant="flat" @click="loadData(active_tab,'filter')">Apply Filter(S)</v-btn >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Image show popup -->
    <v-dialog v-model="dialogVisible" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title class="d-flex">
          <span class="headline">Images</span>
          <v-spacer></v-spacer>
          <v-btn variant="solo" icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text>
          <v-row>
            <v-col v-for="(imageUrl, index) in item_images" :key="index" cols="4">
              <img :src="imageUrl" width="100%" contain @click="openImagePopupSingle(imageUrl)" class="img-rad-size" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="approvalHistoryPopup" persistent max-width="1100">
      <v-card class="v-card-100">
        <v-card-title class="d-flex align-center">
          <span class="headline">Approval History</span>
          <v-spacer></v-spacer>
          <v-btn icon variant="solo" @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text>
          <v-data-table
            density="compact"
            :dense="true"
            v-model="approvalHistory"
            :items="history_table_data"
            disable-pagination
            :hide-default-footer="false"
            :headers="Historyheaders"
            :loading="loading"
            fixed-header
            loading-text="Loading Data... Please wait"
            class="elevation-1 overflow-auto"
          >
          <template v-slot:[`item.created_at`]="{ item }">
            {{ formatTimestamp(item.created_at) }}
          </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions center>
          <v-spacer></v-spacer>
          <v-btn color="primary"  variant="flat" class="mb-3 text-none" @click="closeDialog">Okay</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="imagePopup" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title class="d-flex">
          <v-spacer></v-spacer>
          <v-btn icon @click="imagePopup = false;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-img :src="selectedImage" width="100%" style="border-radius:8px;" contain></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Popups for approval and rejection -->
    <v-row justify="center">
      <v-dialog v-model="approvePopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="approvePopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span
              ><strong>{{ successmessage }}</strong>
            </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" @click="loadData" class="mb-3 text-none">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="rejectPopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn icon @click="rejectPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span
              ><strong
                >{{ selected.length }}. Sub Request Id successfully
                Rejected</strong
              >
            </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" @click="rejectPopup = false" class="mb-3 text-none"
              >Ok</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Download Popup -->
    <v-row justify="center">
      <v-dialog v-model="downloadPopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn icon @click="downloadPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span>Csv file downloaded Successfuly !</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" class="mb-3 text-none">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- search -->
     <v-card class="v-card-100 mt-6">
        <v-tabs color="primary" v-model="selected_tab">
          <v-tab class="component-tab-heading" ripple :href="'#'" @click="loadData(tab, 'tab_clicked')"
            style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in tabs"
            :key="index">{{ tab }}</v-tab>
        </v-tabs>
      </v-card>
    <v-card-title class="action-style pb-0">
      <!-- Search fields -->
      <v-row class="mx-3 mt-4 mb-1">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" color="primary" style="max-width: 270px;" variant="outlined" v-on:keyup.enter="loadData(active_tab, 'search_action')"></v-text-field>
          <DynamicHeader :headers="headers" :totalHeaderList="complete_headers" :updateHeaders="updateHeaders" :componentKey="active_tab" :saved_data_headers="handleSavedHeader"/>
          <v-spacer></v-spacer>
      <!-- Actions buttons -->
      <v-card-actions style="margin-bottom: 15px;">
        <v-menu offset-y v-if="currentUser !== 'default_user'">
          <template v-slot:activator="{ props }">
            <v-btn
              variant="flat"
              color="primary"
              v-bind="props"
              :disabled="selected.length == 0"
              class="text-none"
              size="x-large"
            >
              Approval Decision
              <v-icon dark>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="approveDecision('Approve')">
              <v-list-item-title>Approve</v-list-item-title>
            </v-list-item>
            <v-list-item @click="approveDecision('Reject')">
              <v-list-item-title>Reject</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div v-if="!(organization_name == 'Voltas' || organization_name == 'Crompton' || organization_name == 'Blubirch')">
          <v-btn variant="flat" class="ma-2 text-none" size="x-large" :color="disableActionBtns() ? 'secondry' : 'primary'" :disabled="disableActionBtns()" @click="download_incomplete_file">Download</v-btn>
          <v-btn variant="flat" class="ma-2 text-none" size="x-large" color="primary" @click="navigateToFileUpload()">Upload</v-btn>  
        </div>
      </v-card-actions>

       <!-- Filter -->
          <v-expansion-panels class="custom-control_outlined m-0 pt-2" ref = "filterPopupRef" readonly style="max-width: 110px; margin-bottom: 16px; height: 52px;">
          <v-expansion-panel variant="outlined" @click="filterListOfButtons" >
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
    </v-row>
    </v-card-title>
    <!-- Data Table -->
    <v-layout column>
        <v-data-table 
          hover
          :dense="true"
          density="compact"
          v-model="selected"
          :items="table_data"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :loading="loading"
          fixed-header
          height="100%"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait"
          return-object
          class="elevation-1"
        >
            <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key == 'depriciation'">
                <span style="display:flex;" v-if="['branch_sales_manager', 'regional_business_head', 'product_head', 'branch_finance_manager', 'regional_finance_manager'].includes(currentUser)">
              <v-text-field
                dense
                v-model="item.depriciation"
                variant="outlined"
                @input="formatDepreciation(item)"
                v-on:keyup.enter="updateAmountAndDate(item)"
                :min="0"
                class="align-bottom"
                disabled
                width="100px"
              ></v-text-field>
                <v-tooltip right class="custom-tooltip">
                  <template v-slot:activator="{ props }">
                    <v-icon style="font-size:20px !important; top:-3px !important;" color="secondary" v-bind="props" class="ml-2">mdi-alert-octagon</v-icon>
                  </template>
                  <span>
                    Purchase Date: {{ shouldShowActualValue ? formatDate(item.dealer_purchase_invoice_date) : '****' }}<br>
                    Ageing: 
                     <span v-if="shouldShowActualValue">
                        <span v-if="item.depreciation_from === 731 && item.depreciation_to === null"> <v-icon>mdi-chevron-right</v-icon>{{ item.depreciation_from }}</span>
                        <span v-else>{{ item.depreciation_from || 0}} - {{ item.depreciation_to || 0}}</span>
                      </span>
                      <span v-else>****</span><br>
                    Percentage: {{ shouldShowActualValue ? item.depreciation_percent : '****' }}
                  </span>
                </v-tooltip>
              </span>
              <span v-else>
                **** 
                <v-tooltip right class="custom-tooltip">
                  <template v-slot:activator="{ props }">
                    <v-icon style="font-size:20px !important; top:-3px !important;" color="secondary" v-bind="props" class="ml-2">mdi-alert-octagon</v-icon>
                  </template>
                  <span>
                    Purchase Date: {{ shouldShowActualValue ? formatDate(item.dealer_purchase_invoice_date) : '****' }}<br>
                    Ageing: <span v-if="shouldShowActualValue">{{ item.depreciation_from || '-' }} - {{ item.depreciation_to || '-' }}</span><span v-else>****</span><br>
                    Percentage: {{ shouldShowActualValue ? item.depreciation_percent : '****' }}
                  </span>
                </v-tooltip>
              </span>              
            </span> 
              <span v-else-if="header.key == 'dealer_purchase_value'">
                <span v-if="['branch_sales_manager', 'regional_business_head', 'product_head', 'branch_finance_manager', 'regional_finance_manager'].includes(currentUser)">
                  <v-text-field
                    dense
                    v-model="item.formatted_purchase_price"
                    variant="outlined"
                    @input="formatPurchasePrice(item)"
                    @keyup.enter="updateAmountAndDate(item)"
                    :min="0"
                    class="align-bottom"
                    disabled
                  ></v-text-field>
                </span>
                <span v-else>***</span>           
              </span>
              <span v-else-if="header.key == 'dealer_purchase_invoice_date'">
              <v-menu 
                ref="item.menu" 
                v-model="item.menu" 
                :close-on-content-click="false" 
                :return-value="item.dealer_purchase_invoice_date"
                 transition="scale-transition" 
                offset-y 
                min-width="290px">
                  <template v-slot:activator="{ props }">
                      <v-text-field 
                      variant="outlined"
                      v-model="item.correct_format"
                      readonly
                      hide-details
                      dense
                      v-bind="props"
                      :disabled="organization_name !== 'Crompton' && organization_name !== 'Blubirch'"
                      ></v-text-field>
                  </template>
                  <v-card class="m-0 overflow-hidden calendar-layout" width="315">
                       <v-date-picker  v-model="item.dealer_purchase_invoice_date" hide-header color="primary" min-width="200" max-width="315" scrollable>
                       </v-date-picker>
                       <v-card-action class="d-flex justify-end pb-3">
                         <v-spacer></v-spacer>
                         <v-btn variant="text" color="primary" @click="item.menu = false">Cancel</v-btn>
                         <v-btn variant="text" color="primary" @click="updateAmountAndDate(item)">OK</v-btn>
                       </v-card-action>
                     </v-card>
                  </v-menu>   
          </span>                
            <span v-else-if="header.key == 'expected_liquidation'">
              <v-text-field
              dense
              hide-details
              v-model="item.expected_liquidation"
              variant="outlined"
              @input="formatCurrency(item.expected_liquidation)"
              @keyup.enter="updateAmountAndDate(item)"
              :min="0"
              class="align-bottom"
            ></v-text-field>              
          </span>
              <span v-else-if= "(header.title && header.title.includes('₹'))"> {{ formatCurrency(item[header.key]) }}</span>
              <span v-else-if="header.key == 'return_sub_request_id'">
                <a href="#" @click.prevent="subRequestDialog(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.return_sub_request_id }}</a>
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <GlobalTooltip :text="item[header.key]" />
              </span>
              <span v-else-if="header.key === 'images' && item.images && item.images.length > 0">
                <a @click.prevent="viewCustomerDeclarationImages(item)" style="text-decoration: underline; color:#1976d2; cursor: pointer;">
                  View Image
                </a>
              </span>
              <span v-else-if="header.key === 'approval_history' && item.has_approval_history === true && !item.update">
                <a @click="viewApprovalHistory(item)">
                  <span style="text-decoration: underline; color:#1976d2; cursor: pointer;">View</span>
                </a>
              </span>
              <span v-else-if="header.key === 'dealer_pan' && item.has_approval_history === true && !item.update">
                <span v-if="item.dealer_pan && item.dealer_pan != item.customer_name" style="color: red;">
                {{ item.dealer_pan }}
                </span>
                <span v-else>{{ item.dealer_pan ? item.dealer_pan : '-' }}</span>
              </span>

              <span v-else-if="header.key == 'item_location'">
                <span v-if="item.item_location !== null && item.item_location.length <= 30">
              {{ item.item_location }}
            </span>
            <span v-else-if="item.item_location === null">
              N/A
            </span>
            <span v-else>
              <v-tooltip location="top" text="item.item_location">
                <template v-slot:activator="{ props }">
                  <a v-bind="props" style="color: #1976d2;" @click="showFullText(item.item_location)">
                    {{ item.item_location.substring(0, 25) }}...
                  </a>
                </template>
                <span>{{ item.item_location }}</span>
              </v-tooltip>
            </span>              
          </span>
          
          <span v-else-if="header.key == 'dealer_pan'">
            <span v-if="item.dealer_pan && item.dealer_pan != item.customer_name" style="color: red;">
              {{ item.dealer_pan }}
            </span>           
          </span>               
               
            <span v-else>-</span>
           </template>
          <template #bottom></template>
        </v-data-table>
    </v-layout>

    <!-- pagination display -->
       <div>
           <PaginationComponent
               :pageSize="pageSize"
               :pageSizes="pageSizes"
               :totalCount="totalCount"
               :selected="selected"
               :page="page"
               :totalPages="totalPages"
               @update:pageSize="handlePageSizeChange"
               @update:page="handlePageChange"
               class="mt-2 mb-0"
           />
       </div>
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import DynamicHeader from "@/components/commoncomponents/DynamicHeader.vue";
export default {
  components: {
    HeaderComponent, DynamicHeader
  },
  data() {
    return {
      headerText: "Dealer/Partner Return Approval",
      selected: [],
      search_tag: "",
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      row: null,
      table_data:[],
      isDisabled: true,
      enabled: false,
      selectedOption: null,
      filterPopup: false,
      return_ids: [],
      item_details: "",
      index: "",
      expected_liquidation: "",
      depriciation: "",
      purchase_date: "",
      purchase_price: "",
      rows: [
        {
          name: "",
          item_decision: ""
        }
      ],
      ra_branch_search: "",
      ra_location_search: "",
      region_search: null,
      return_type_search: "",
      search: "",
      alert_message: "",
      alert_type: "info",
      alert: false,
      loading: false,
      regions: "",
      return_types: "",
      downloadPopup: false,
      approvePopup: false,
      rejectPopup: false,
      purchase_price: "",
      menu: false,
      dealer_sales: "",
      service_cost: "",
      service_cost_percent: "",
      successmessage: "",
      currentUser: "",
      dialogVisible: false,
      item_images: [],
      imagePopup: false,
      selectedImage: '',
      organization_name:'',
      approvalHistoryPopup: false,
      approvalHistory: [],
      history_table_data: [],
      Historyheaders: [],
      click_data: {},
      selected_tab:0,
      is_filter:false,
      complete_headers: [],
      beforeHeaders: [],
      headers: [],
      active_tab: "Dealer/ Partner Approval",
      isSavedHeaderUsed: false,
      tabs: ["Dealer/ Partner Approval","Customer Approval","D2C Sales Return"]
    };
  },

  created() {
    if(this.$store.state.navigate_tab.navigate_tab === 'Customer Approval'){
      this.selected_tab = 1;
      this.loadData("Customer Approval");
    }else if(this.$store.state.navigate_tab.navigate_tab === 'Dealer/ Partner Approval'){
      this.selected_tab = 0;
      this.loadData("Dealer/ Partner Approval");
    }else if(this.$store.state.navigate_tab.navigate_tab === 'D2C Sales Return'){
      this.selected_tab = 2;
      this.loadData("D2C Sales Return");
    }else{
      this.loadData("Dealer/ Partner Approval");
    }
    this.currentUser = this.$store.state.currentUser.roles[0];
    this.organization_name = this.$store.state.organization_name
  },  
  watch: {
  'table_data': {
    handler(newVal, oldVal) {
      newVal.forEach(item => {
        if (!isNaN(item.dealer_purchase_value)) {
          item.formatted_purchase_price = this.formatCurrency(item.dealer_purchase_value);
        }
        if (!isNaN(item.depriciation)) {
          item.formatted_depreciation = this.formatCurrency(item.depriciation);
        }
        if (!isNaN(item.expected_liquidation)) {
          item.expected_liquidation = this.formatCurrency(item.expected_liquidation);
        }
      });
    },
    deep: true // Ensure deep watching for changes inside objects
  }
},
  computed:{
    formatted_table_data(){
      return this.table_data.map((item) => {
        const formattedItem = { ...item };
        this.headers.forEach((header) => {
          if (header.text && header.text.includes("₹")) {
            formattedItem[header.key] = this.formatCurrency(item[header.key]);
          }
        });
        return formattedItem;
      });
    },
    shouldShowActualValue() {
     return this.currentUser === 'branch_sales_manager' ||
           this.currentUser === 'regional_business_head' ||
           this.currentUser === 'product_head' || 
           this.currentUser === 'branch_finance_manager' || 
           this.currentUser === 'regional_finance_manager';
  }
  },
  methods: {
    updateHeaders(headers){
          this.beforeHeaders = headers.map(header => header)
          this.headers = headers
        },
        handleSavedHeader(savedData) {
        this.isSavedHeaderUsed = savedData;
        console.log('Saved headers used:', savedData); // true or false
      },
    formatPurchasePrice(item) {
      const numericValue = parseFloat(item.formatted_purchase_price.replace(/[^0-9.]+/g, ''));
      if(!isNaN(numericValue)){
        item.formatted_purchase_price = this.formatCurrency(numericValue);
        item.dealer_purchase_value = isNaN(numericValue) ? null : numericValue;
      } else {
        item.formatted_purchase_price = "";
        item.dealer_purchase_value = null;
      }
    },
    formatDepreciation(item) {
      const numericValue = parseFloat(item.formatted_depreciation.replace(/[^0-9.]+/g, ''));
      if(!isNaN(numericValue)){
        item.formatted_depreciation = this.formatCurrency(numericValue);
        item.depriciation = isNaN(numericValue) ? null : numericValue;
      } else {
        item.formatted_depreciation = "";
        item.depriciation = null;
      }
    },
    formatCurrency(value){
      return Number(value).toLocaleString('en-IN');
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      let hour = date.getHours();
      const minute = date.getMinutes();
      const amPM = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12 || 12;
      const formattedTime = `${hour}:${minute.toString().padStart(2, '0')} ${amPM}`;
      return `${day}/${month}/${year}, ${formattedTime}`;
    },
    formatExpectedLiquidation(item) {
      const numericValue = parseFloat(item.expected_liquidation.replace(/[^0-9.]+/g, ''));
      if (!isNaN(numericValue)) {
        item.expected_liquidation = this.formatCurrency(numericValue);
        item.expected_liquidation = numericValue;
      } else {
        item.expected_liquidation = '';
        item.expected_liquidation = null;
      }
    },
    viewCustomerDeclarationImages(item) {
      this.dialogVisible = true;
      this.item_images = item.images
    },
    openImagePopupSingle(image) {
      this.selectedImage = image;
      this.imagePopup = true;
    },
    closeDialog(){
      this.dialogVisible = false;
      this.approvalHistoryPopup = false;
    },
    // show Alert messages
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    loadData(tab, tab_clicked) {  
      if(tab_clicked === 'tab_clicked') {
          this.search_tag = '';
         }    
       if(tab_clicked === 'filter'){
         this.is_filter = true
        }else{
          this.is_filter = false;
        }
      this.loading = true;
      this.approvePopup = false;
      this.active_tab = tab
      this.$store.commit("setNavigateTab", { navigate_tab:this.active_tab});
      this.selected = [];
      this.table_data = [];
      this.page = 1;
      this.totalPages = 1;
      if((tab == "Customer Approval" || tab == "D2C Sales Return") && this.isSavedHeaderUsed == false){
        this.headers = [
        {title: "Client CRM Ticket No.", sortable: false, key: 'client_crm_ticket_no', minWidth: "200px"},
        { title: "Sub-request ID", align: "start", sortable: false, key: "return_sub_request_id", minWidth: "200px" },
        { title: "BB Ticket No.", key: "bb_ticket_no", minWidth: '200px'},
        { title: "Ageings", key: "ageing", minWidth: "200px" },
        { title: "Customer", key: "customer_name", minWidth: "200px" },
        { title: "Location", key: "item_location", minWidth: "200px" },
        { title: "Branch", key: "branch", minWidth: "200px" },
        { title: "Region", key: "region", minWidth: "200px" },
        { title: "Article ID", key: "sku_code", minWidth: "200px" },
        { title: "Category", key: "category_name", minWidth: "200px" },
        { title: "Zone", key: "zone", minWidth: "200px" },
        { title: "Validation", key: "policy", minWidth: "200px" },
        { title: "Repairable", key: "repairable_status", minWidth: "200px" },
        { title: "Repair Cost (₹)", key: "repair_cost", minWidth: "200px" },
        { title: "Repair Cost (%)", key: "repair_cost_percent", minWidth: "200px" },
        { title: "Customer Resolution Decision", key: "customer_resolution_decision", minWidth: "270px" },
        { title: "Images", key: "images", minWidth: "200px"},
        { title: "Approval History", key: "approval_history", minWidth: "200px"},
        { title: "Item Decision", key: "item_decision", minWidth: "200px" }
      ];      
      }else if(tab == "Dealer/ Partner Approval" && this.isSavedHeaderUsed == false){
        this.headers = [
        {title: "CRM Ticket No.", sortable: false, key: 'client_crm_ticket_no', minWidth: "200px"},
        {
          title: "Sub-request ID",
          align: "start",
          sortable: false,
          key: "return_sub_request_id",
          minWidth: "200px"
        },
        { title: "BB Ticket No.", key: "bb_ticket_no", minWidth: "200px"},
        { title: "Ageings", key: "ageing", minWidth: "200px" },
        { title: "Customer", key: "customer_name", minWidth: "200px" },
        { title: "Purchase Dealer", key: "dealer_pan", minWidth: "200px"},
        { title: "Location", key: "item_location", minWidth: "200px" },
        { title: "Branch", key: "branch", minWidth: "200px" },
        { title: "Region", key: "region", minWidth: "200px" },
        { title: "Article ID", key: "sku_code", minWidth: "200px" },
        { title: "Category", key: "category_name", minWidth: "200px" },
        { title: "Zone", key: "zone", minWidth: "200px" },
        { title: "Validation", key: "policy", minWidth: "200px"},
        { title: "Purchase Price (₹)", key: "dealer_purchase_value", minWidth: "200px" },
        { title: "Purchase Date", key: "dealer_purchase_invoice_date", minWidth: "200px" },
        { title: "Depreciation (₹)", key: "depriciation", minWidth: "200px" },
        { title: "Expected Liquidation (₹)", key: "expected_liquidation", minWidth: "220px" },
        { title: "Repairable", key: "repairable_status", minWidth: "200px" },
        { title: "Repair As Value(₹)", key: "repair_cost", minWidth: "200px" },
        { title: "Repair Cost %", key: "repair_cost_percent", minWidth: "200px" },
        {title: "Customer Resolution Decision", key: "customer_resolution_decision", minWidth: "270px" },
        {title: "Images", key: "images", minWidth: "200px"},
        {title: "Approval History", key: "approval_history", minWidth: "200px" },
        { title: "Item Decision", key: "item_decision", minWidth: "200px" }
      ];
      }
      this.fetchTableData();
      if(!this.isSavedHeaderUsed){
         if(this.is_filter === false){
           this.complete_headers = this.headers.map(item => item)
           this.headers = this.headers.map(item => item)
          }else {
            this.complete_headers = this.headers.map(item => item)            
            this.headers = this.beforeHeaders.length > 0 ? this.beforeHeaders : this.headers.map(item => item)
          }
      }
      
      
    },
    getRequestParams(page, pageSize, filterPage) {
          let params = {};
  
          if (page) {
            params["page"] = page;
          }
          if (pageSize) {
            params["size"] = pageSize;
          }

          if (filterPage) {
            params["filterPage"] = filterPage;
          }

          return params;
        },
    viewApprovalHistory(item){
      this.loading = true;
      this.Historyheaders = [
        { title: "Date & Time", key: "created_at"},
        { title: "Approver Name & ID", key: "approver_name", sortable: false },
        { title: "Approver Role", key: "approver_role"},
        { title: "Decision", key: "decision" },
        { title: "Remarks", key: "remarks" },
        { title: "Action", key: "status" },
      ];
      this.$httpSecured
      .get(`/api/v1/warehouse/return_initiation/return_approvals/${item.id}/approval_histories`)
      .then(response => {
        if(response.data) {
          this.history_table_data = response.data.data
          this.approvalHistoryPopup = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.showAlert("error", "No Data Found");
        }
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
        this.loading = false;
      });
    },

    // filter Dialog PopUP
    filterListOfButtons(ev) {
      this.search_tag = "";
      this.filterPopup = true;
      document.documentElement.style.setProperty(
        "--dialog-ypos",
        (
          this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40
        ).toString() + "px"
      );
    },

    // Apply Filters Function
    applyFilterFunc() {
      const params = new URLSearchParams();
      params.append("return_type", this.request_type_search);
      params.append("return_request_id", this.return_request_id_search);
    },

    // close filter popup and clear all the fields
    closeFilterpopup() {
      this.filterPopup = false;
      this.request_type_search = "";
        this.ra_location_search = "";
        this.region_search = "";
        this.ra_branch_search = "";
    },

    // fetch table data
    fetchTableData() {
      this.loading = true;
     const params = {
        page: this.page,
        per_page: this.pageSize,
        ...(this.search_tag ? { search: this.search_tag } : {}),
        ...(this.ra_location_search ? { location: this.ra_location_search } : {}),
        ...(this.ra_branch_search ? { branch: this.ra_branch_search } : {}),
        ...(this.region_search ? { region: this.region_search } : {}),
      };
      let end_point;
      if(this.active_tab === 'Customer Approval'){ 
        end_point = `/api/v1/warehouse/return_initiation/return_approvals?return_type=Warranty Claim`;
      }else if(this.active_tab === 'D2C Sales Return'){
        end_point = `/api/v1/warehouse/return_initiation/return_approvals?return_type=D2C Sales Return`;
      }else{
        end_point = `/api/v1/warehouse/return_initiation/return_approvals?return_type=Dealer-Partner Sales Return`;
      }
      this.$httpSecured
        .get(end_point, { params: params }
        )
        .then(response => {
          if (response.data) {
            response.data.return_items.forEach(item => {
                item.correct_format = this.formatDate(item.dealer_purchase_invoice_date);
                item.dealer_purchase_invoice_date = new Date(item.dealer_purchase_invoice_date ? item.dealer_purchase_invoice_date : new Date());
              });
            this.table_data = response.data.return_items;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.dealer_sales = this.formatCurrency(response.data.meta.dealer_sales);
            this.service_cost = this.formatCurrency(response.data.meta.service_cost);
            this.service_cost_percent = response.data.meta.service_cost_percent;
            this.filterPopup = false;
            this.loading = false;
            this.closeFilterpopup()
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    formatDate(dateString) {
      if (!dateString) return ''; // Return empty string if dateString is null
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // January is 0
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    },
    searchData() {
      const params = new URLSearchParams();
      params.append("search", this.search_tag);
      params.append("page", this.page);
      params.append("per_page", this.pageSize);
    },

    subRequestDialog(item) {
      let tabName = '';
      if(this.active_tab === 'Customer Approval'){
        tabName = 'Warranty Claim Approval'
      }else if(this.active_tab === 'D2C Sales Return'){
        tabName = 'D2C Return Approval'
      }else{
        tabName = 'Dealer/Partner Return Approval'
      }
      const initialApprovalValues =  item.is_initial_request_approval
        this.$store.commit("setUnique", {
        set_unique: initialApprovalValues
      });
        
      this.$store.commit("setLotIds", {
        lotIds: item,
        action: 'by_link_approve',
        inventoryId:tabName
      });
      this.$router.push({ name: "sub_request_approval" });
    },

    disableActionBtns() {
      if (this.selected.length === 0) {
        return true;
      }

      const firstSelectedType = this.selected[0];

      for (const type of this.selected) {
        if (type !== firstSelectedType) {
          return true;
        }
      }

      return false;
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchTableData();
    },
    handlePageChange(value) {
      this.page = value;
      this.fetchTableData();
    },
    downloadCsv() {
      this.downloadPopup = true;
    },
    approveDialog() {
      this.approvePopup = true;
    },
    rejectDialog() {
      this.rejectPopup = true;
    },
    updateAmountAndDate(item) {
      const formData = new FormData();

      if (item.dealer_purchase_value) {
        const purchaseValue = item.dealer_purchase_value.toString().replace(/,/g, '');
        formData.append('purchase_price', purchaseValue);
      }

      if (item.dealer_purchase_invoice_date) {
        const purchaseDate = this.formatDate(item.dealer_purchase_invoice_date).toString();
        formData.append('purchase_date', purchaseDate);
      }

      if (item.expected_liquidation) {
        const expectedLiquidation = item.expected_liquidation.toString().replace(/,/g, '');
        formData.append('expected_liquidation', expectedLiquidation);
      }

      formData.append('depriciation', item.depriciation.toString().replace(/,/g, ''));


      this.$httpSecured  
              .put(
                `/api/v1/warehouse/return_initiation/return_approvals/${item.id}`,
                formData
              )
              .then(response => {
                if (response.data) {
                  this.$toast.success(response.data.message);
                  this.loadData();
                } else {
                  this.showAlert("error", "Something went wrong");
                }
              })
              .catch(error => {
                this.showAlert("error", error.response.data.error);
                this.loading = false;
                this.isSubmitted = false;
              });
          },
    approveDecision(value) {
      this.number++;
      const itemId = this.selected.map(table_data => table_data.id);
      const params = {
        ids: itemId,
        action_type: value,
        is_bulk_approve: true
      };
      if(value === 'Approve'){
        if(this.selected.length > 0){
          const initialApprovalValues = [...new Set(this.selected.map(item => item.is_initial_request_approval))];
            if(initialApprovalValues.length === 1 && initialApprovalValues[0] === true && this.selected.length > 1){
                this.showAlert("error", "Initailly approver should select single request.");
                return;        
              }
            if(initialApprovalValues.length > 1) {
              this.showAlert("error", "Selected request should be initailly or further level.");
              return;
            }
          this.$store.commit("setUnique", {
          set_unique: initialApprovalValues
        });
      }     
      if(this.active_tab === "Dealer/ Partner Approval" && (this.organization_name !== "Crompton" && this.organization_name !== "Blubirch")){
          let errors = [];
          for (const item of this.selected) {
            if (!item.purchase_price || !item.dealer_purchase_invoice_date) {
              errors.push(`Request ID ${item.return_sub_request_id}: Purchase price and Date are mandatory.`);
            }
          }
          if (errors.length > 0) {
            this.showAlert("error", errors.join('\n'));
            return;
          }
        }
        let tabName = '';
        if(this.active_tab === 'Customer Approval'){
          tabName = 'Warranty Claim Approval'
        }else if(this.active_tab === 'D2C Sales Return'){
          tabName = 'D2C Return Approval'
        }else{
          tabName = 'Dealer/Partner Return Approval'
        }
        this.$store.commit("setLotIds", {
          lotIds: this.selected.length === 1 ? this.selected[0] : itemId,
          action: this.selected.length === 1 ? 'single_item_approve' : 'from_home_approve',
          inventoryId:tabName,        
        });
        this.$store.commit("setActiveTab", {
          active_tab: this.selected
        });
        this.$router.push({ name: "sub_request_approval" });
      }else{
        this.$httpSecured
        .post(
          "/api/v1/warehouse/return_initiation/return_approvals/bulk_approve",
          params
        )
        .then(response => {
          if (response.data) {
            this.approvePopup = true;
            this.successmessage = response.data.message;
            this.successpopup = true;
            this.number = 0;
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
        });
      }
     
    },
    download_incomplete_file(){
        const selected_id = this.selected.map( x=> x.id)
        const params = {
            "ids" : selected_id
        }
        this.$httpSecured.
        get("/api/v1/warehouse/return_initiation/return_approvals/download",{ params }
        )
        .then(response => {
        if (response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Dealer-Incomplete-Items.csv`);
            document.body.appendChild(link);
            link.click();
            this.message = "CSV for prd ( ";
            for( var i=0;i<Math.min(this.selected.length,3); i++){
                if( i==0){
                    this.message += this.selected[i].prd_number
                } else {
                    this.message +=", " + this.selected[i].prd_number
                }
            }
            if(this.selected.length>3){
                this.message +=",... "
            }
            this.message+=" ) Successfully Downloaded.";
            this.okapproveconfirmpopup = true;
            this.action_name = 'success';
            this.confirmedClicked = true;
        }
        })
        .catch(error => {
            this.$toast.error(error.response.data.error)
        });
    },
    navigateToFileUpload() {
       this.$store.commit("setLotIds", {
        lotIds: "d2c_return_approval",
        inventoryId: "Dealer/Partner Return Approval"
      });
      this.$router.push({ name: "LotFileuploadComm" });
    },
  }
};
</script>
<style scoped>
.label-print {
  text-decoration: underline;
  color: #0357d0;
  cursor: pointer;
  box-shadow: none !important;
  padding: 0 !important;
  height: 0 !important;
}
.generate-label {
  color: #19b100;
}
.v-dialog:has(.filter-repair) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}

.link-color {
  color: #0357d0;
  font-size: 14px;
  font-weight: 600;
}

.bg-color {
  background: #0357d0;
  color: #ffffff;
}

.fieldset {
  background: #0357d0;
}

.v-label {
  position: relative !important;
  margin-top: 50px !important;
}
.img-rad-size {
  width: 186px;
  height: 184px;
  border-radius: 8px;
}
.disable-text-color {
  color: #9f9d9d;
}

.downloadMessagePopup {
  background-color: black;
  color: white;
  position: absolute;
  bottom: 6%;
  padding: 24px;
}
.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}
.v-data-table.approval-history {
  height: calc(var(--vh, 1vh) * 100 - 400px) !important;
}
@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}
:deep(.align-bottom .v-text-field__details){
  display: none !important;
}
 .v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 325px) !important;
}
.custom-control_outlined button {
      min-height: 52px;
      border-width: 1px;
      border-radius: 4px;
      border-color: rgba(0,0,0,.42);
      border-style: solid;
    } 
.v-tooltip__content {
  background-color: white !important; 
  color: black !important;           
  border: 1px solid #ccc;            
  padding: 10px;                     
  font-size: 14px;                  
}  
.filter_ui{
    margin-left: 28px !important;
    margin-top: 12px !important;
 }
 :deep(.table-height-cunstom .v-data-table__wrapper) {
  height: calc(var(--vh, 1vh) * 100 - 400px) !important;
}
:deep(.v-tab--selected){
  background-color: #dbe6ff !important;
  color: #1976d2 !important;
}
</style>
